export { default as SmashingCGIIcon } from './SmashingCGIIcon';
